import { GroupChatAnnouncementDetailScreenNavigationProps } from "./types"
import React from "react"
import GroupChatAnnouncementDetail from "./group-announcement-detail-screen"
import { PageRoot } from "~screens/page-root"


const GroupChatAnnouncementDetailScreen: React.FC<GroupChatAnnouncementDetailScreenNavigationProps> = (props) => {
  return (
    <PageRoot>
      <GroupChatAnnouncementDetail {...props}/>
    </PageRoot>
  )
}

export default GroupChatAnnouncementDetailScreen
